import { render, staticRenderFns } from "./upload_files.vue?vue&type=template&id=0d8a34cb"
import script from "./upload_files.vue?vue&type=script&lang=js"
export * from "./upload_files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports